import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { usePortfolioReportsQuery } from '../../api/usePortfolioReportsQuery';
import { PortfolioReportParams } from '../PortfolioReportParams/PortfolioReportParams';
import { ReportSelect } from '../ReportSelect/ReportSelect';

export const PortfolioReportForm: React.FC = () => {
  const { isLoading, isError, refetch } = usePortfolioReportsQuery();

  if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <Loading text="Loading..." size="large" />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        flex={1}
      >
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  return (
    <Box width={420}>
      <ReportSelect mt="24" />

      <PortfolioReportParams />
    </Box>
  );
};
